import React from 'react'
import { Typography, Button } from '@material-tailwind/react';
import { Link } from 'react-router';

const Banner = ({ bannerDetails, Category }) => {
    return (
        <div className="relative w-full lg:h-[70vh]">
            <div>
                <img
                    src={bannerDetails.image}
                    alt={bannerDetails.alt}
                    className="h-[70vh] w-full object-cover"
                />
            </div>
            <div className="absolute inset-0 grid h-full w-full place-items-center bg-black/50">
                <div className="w-3/4 text-center md:w-2/4 mt-12">
                    <Typography
                        variant="h1"
                        color="white"
                        className="mb-4 text-3xl md:text-4xl lg:text-5xl title_DMSerifText-Regular uppercase"
                    >
                       {Category} {bannerDetails.title}
                    </Typography>
                    <Typography
                        variant="lead"
                        color="white"
                        className="mb-12 opacity-80 lg:text-2xl text_CormorantGaramond-Regular"
                    >
                       {bannerDetails.description}
                    </Typography>
                    <div className="flex gap-2 justify-center">
                        {/* <Link to={'/BookNow'}>
                            <Button size="lg" color="white">
                                Book Now
                            </Button>
                        </Link>
                        <Link to={'/Gallery'}>
                            <Button size="lg" color="white" variant="text">
                                Gallery
                            </Button>
                        </Link> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner